<template>
  <v-toolbar
    color="blue darken-3"
    dark
    app
    :clipped-left="$vuetify.breakpoint.mdAndUp"
    fixed
  >
    <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
      <v-btn flat exact to="/"
        ><img src="../assets/newJuntos_logo_color.png" width="70%"
      /></v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <!-- <v-btn flat exact to="/about">Sobre</v-btn> -->
      <v-btn flat v-if="getUser" @click="signOut">Sair</v-btn>
    </v-toolbar-items>
    <v-btn icon large>
      <v-avatar size="32px" tile>
        <img src="../assets/miniatura.png" alt="Juntos Energia" />
      </v-avatar>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUser"]),
    hide() {
      return this.$route.path === "/login" || this.$route.path === "/register";
    },
  },
  methods: {
    ...mapActions(["logout"]),
    signOut() {
      this.logout().then(() => {
        localStorage.removeItem("user");
        this.$router.replace("/login");
      });
    },
  },
};
</script>

<style scoped></style>
